import { InputNumber, Tooltip } from 'antd'
import { MySlider } from '~/components/ui/MySlider'
import { QuestionCircleOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { creativityDegreeAtom } from './atom'
import { useAtom } from 'jotai'
import styles from '../AiForm.module.css'

export const CreativityDegreeComp = () => {
  const [creativityDegree, setCreativityDegree] = useAtom(creativityDegreeAtom)

  return (
    <div className="flex items-center mb-4">
      <span className={classNames('text-neutral-500 w-[120px]')}>
        创意度{' '}
        <Tooltip
          placement="topLeft"
          arrowPointAtCenter
          title="创意度越低生成图片越接近参考图，创意度越高生成图片越有创意"
        >
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
      <MySlider
        className="flex-1"
        step={1}
        value={creativityDegree}
        onChange={val => {
          setCreativityDegree(val)
        }}
      />
      <InputNumber
        min={0}
        max={100}
        className={styles.inputNumberGroup}
        value={creativityDegree}
        onChange={val => {
          setCreativityDegree(Number(val?.toFixed(0)))
        }}
        addonAfter="%"
      />
    </div>
  )
}
